import _ from 'lodash';

import { BILLETTERIE_ROOT } from '../../constants';
import { PATH } from '../../constants/path';
import { minusAmount, multiplyAmount } from '../../utils/mathUtils';

export const isBilletterie = partner => !!(partner && partner.billetterie);

// Fiche de la zone billetterie : id partenaire MB brut, sans slug
export const getBilletterieMerchantUrl = ({ id }) =>
    id ? `${BILLETTERIE_ROOT}${PATH.BILLETTERIE_MERCHANT_PATH}${id}` : '';

// Mur d'offres de la zone billetterie
export const getBilletterieWallUrl = () => `${BILLETTERIE_ROOT}${PATH.BILLETTERIE_PATH}`;

// Cashback appliqué en remise immédiate sur le billet, comme la fiche de la zone
const getBilletterieCashbackPercent = partner =>
    _.get(partner, 'ebonDiscount.cashback.percent.value') || 0;

// « À partir de » : prix minimum remisé du cashback, sinon public (enseigne qui masque son minimum)
export const getBilletteriePrice = partner => {
    if (!partner) return undefined;
    if (partner.minPrice > 0) {
        const rate = minusAmount(1, getBilletterieCashbackPercent(partner) / 100);
        return multiplyAmount(partner.minPrice, rate);
    }
    return partner.minPricePublic || undefined;
};

export const hasBilletteriePrice = partner => getBilletteriePrice(partner) > 0;

// Prix public barré seulement s'il dépasse le prix remisé
export const hasBilletteriePublicPrice = partner =>
    !!(partner && partner.minPrice > 0 && partner.minPricePublic > getBilletteriePrice(partner));

// Une entrée par carte du mur (venue), comme la zone ; une venue présente dans deux catalogues compte une fois
export const toBilletteriePartners = (venues, partners, ebonPartners) =>
    _.uniqBy(
        venues.filter(venue => venue.partnerId && venue.venueId && venue.ebonDiscount),
        venue => `${venue.partnerId}-${venue.venueId}`
    ).map(venue => {
        const id = Number(venue.partnerId);
        const onlinePartner = partners && partners[id];
        const ebonPartner = _.find(ebonPartners, { id });
        const mbPartner = onlinePartner || ebonPartner;
        const mbName = mbPartner && mbPartner.name;
        const name = venue.title || mbName;

        return {
            id,
            venueId: venue.venueId,
            name,
            nameMatchings: _.uniq(
                [mbName, ...((mbPartner && mbPartner.nameMatchings) || [])].filter(
                    alias => alias && alias !== name
                )
            ),
            logoUrl: venue.logo,
            ebonDiscount: venue.ebonDiscount,
            // Prix remisé de la carte, masqué quand l'enseigne le demande
            minPrice: venue.hidePriceMinimum ? undefined : venue.minPrice,
            minPricePublic: venue.minPricePublic,
            // Données MB de l'annuaire (catégories, nouveautés, épinglage) : absentes hors référentiel MB
            categoriesIds: _.uniq([
                ...((onlinePartner && onlinePartner.categoriesIds) || []),
                ...((ebonPartner && ebonPartner.categories) || [])
            ]),
            // En secondes comme /api/partner (/ebon/partner l'expose en millisecondes)
            creationDate: onlinePartner
                ? onlinePartner.creationDate
                : ebonPartner && ebonPartner.creationDate / 1000,
            categoryDisplayOrders: mbPartner && mbPartner.categoryDisplayOrders,
            billetterie: true
        };
    });



// WEBPACK FOOTER //
// ./src/services/billetterie/utils.js